import { type ActiveState, createEntityStore, type EntityState } from '@datorama/akita';
import { type KpiArea } from 'types/models';

export interface KPIAreasState extends EntityState<KpiArea>, ActiveState {}

const store = createEntityStore<KPIAreasState>({}, { resettable: true, name: 'kpiAreas' });

export default store;
